import { API_BASE, UPLOADS_BASE } from './config';
import defaultAwardImage from '../assets/images/award-certification.jpg';
import { formatArticleDate } from './newsArticlesApi';
import { fetchDoctors } from './doctorApi';
import { fetchEstablishments } from './hospitalApi';

export { UPLOADS_BASE };

const lookupById = (rows = [], idKey) =>
  Object.fromEntries(rows.map((row) => [String(row[idKey]), row]));

export const enrichAwardWithNames = (
  award,
  establishmentsById = {},
  doctorsById = {},
) => {
  const establishment = establishmentsById[String(award.establishment_id)];
  const doctor = doctorsById[String(award.doctor_id)];

  return {
    ...award,
    establishment_name:
      award.establishment_name || establishment?.establishment_name || '',
    doctor_name: award.doctor_name || doctor?.doctor_name || '',
  };
};

export const formatAwardRecipientName = (award = {}) => {
  const parts = [];
  if (award.doctor_name) parts.push(award.doctor_name);
  if (award.establishment_name) parts.push(award.establishment_name);
  return parts.join(' · ');
};

export const resolveAwardRecipientName = formatAwardRecipientName;

async function fetchJson(url) {
  const response = await fetch(url);
  if (!response.ok) {
    const data = await response.json().catch(() => ({}));
    throw new Error(data.message || `Request failed (${response.status})`);
  }
  return response.json();
}

export async function fetchAwardsRecognition(filters = {}) {
  const params = new URLSearchParams();
  if (filters.establishment_id != null) {
    params.set('establishment_id', String(filters.establishment_id));
  }
  if (filters.doctor_id != null) {
    params.set('doctor_id', String(filters.doctor_id));
  }

  const query = params.toString();
  const url = `${API_BASE}/master/awards-recognition${query ? `?${query}` : ''}`;
  const data = await fetchJson(url);
  return Array.isArray(data) ? data : [];
}

export async function fetchAwardsForDisplay(filters = {}) {
  const [awards, establishments, doctors] = await Promise.all([
    fetchAwardsRecognition(filters),
    fetchEstablishments(),
    fetchDoctors(),
  ]);

  const establishmentsById = lookupById(establishments, 'establishment_id');
  const doctorsById = lookupById(doctors, 'doctor_id');

  return awards.map((award) =>
    enrichAwardWithNames(award, establishmentsById, doctorsById),
  );
}

export async function fetchAwardRecognitionById(id) {
  return fetchJson(`${API_BASE}/master/awards-recognition/${id}`);
}

export function mapAwardToCardProps(award) {
  const uploadedImages = (award.images || [])
    .map((img) => `${UPLOADS_BASE}/uploads/${img.image_path}`)
    .filter(Boolean);

  const hospitalName = award.establishment_name || '';
  const doctorName = award.doctor_name || '';

  return {
    id: award.award_id,
    images: uploadedImages.length ? uploadedImages : [defaultAwardImage],
    title: award.award_title,
    description: award.short_note || '',
    hospitalName,
    doctorName,
    recipientName: formatAwardRecipientName(award),
    organization: award.awarding_body || '',
    date: formatArticleDate(award.award_date),
    place: award.place || '',
    certificateUrl: uploadedImages[0] || '',
    hasCertificate: uploadedImages.length > 0,
  };
}
